import UserRepository from './UserRepository';

const repositories = {
  user: UserRepository,
  // Outros repositórios podem ser adicionados aqui
};

export const RepositoryFactory = {
  get: name => repositories[name]
};